<ion-content class="ion-padding">
    <div class="title">
        <h2>
            <ion-text color="primary">
                {{ title | translate }}
            </ion-text>
        </h2>
    </div>
    <div [innerHTML]="message"></div>

    <div class="actions">
        <ion-button fill="outline" (click)="cancel()">
            {{ "generic.cancel" | translate }}
        </ion-button>
        <ion-button mode="ios" color="primary" (click)="save()">
            {{ btnConfirmText | translate }}
        </ion-button>
    </div>
</ion-content>
